<template>
    <div class="video-container" ref="videoContainer"> 
        <video-loader
            ref="video"
            :data="data"
            :style="{width: width+'px', height: height+'px', marginLeft: marginLeft+'px', marginTop: marginTop+'px'}"
            :autoplay=true 
            :loop=true
            @loaded="onVideoLoaded"
        />
        <div class="pixel-overlay"></div>
    </div>
</template>


<script>
import VideoLoader from '@/components/VideoLoader'
import Size from '@/plugins/WindowSize'

export default {
    components: {
        VideoLoader
    },
    
    props: {
        data: {
            // EXAMPLE data - Array with src, widht & height
            // [
            //     {
            //         "url": "video-768x432.mp4",
            //         "width": 768,
            //         "height": 432
            //     },
            //     {
            //         "url": "video-1080x608.mp4",
            //         "width": 1080,
            //         "height": 608
            //     },
            //     {
            //         "url": "video-1920x1080.mp4",
            //         "width": 1920,
            //         "height": 1080
            //     }
            // ]
            
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            videoAspect: null,
            width: 0,
            height: 0,
            marginLeft: 0,
            marginTop: 0,
        }
    },

    created() {
        Size.addListener(this.onResize)
    },
    
    destroyed() {
        Size.removeListener(this.onResize)
    },
    
    mounted() {
        // this.src = this.data.url
        this.videoAspect = this.data[0].width / this.data[0].height
       
    },

    methods: {
        
        onVideoLoaded() {

            this.setVideoSize()
            
            this.$emit('loaded')
        },
        
        // play() {
        //     this.$refs.video.play()
        // },
        // 
        // pause() {
        //     this.$refs.video.pause()
        // },
        
        onResize() {
            this.setVideoSize()
        },
        
        setVideoSize() {
            
            var containerWidth = window.innerWidth //this.$refs.videoContainer.offsetWidth
            var containerHeight = window.innerHeight //this.$refs.videoContainer.offsetHeight
            var containerAspect = containerWidth / containerHeight
            
            // Landscape (wider)
            if (containerAspect >= this.videoAspect) {
                this.width = containerWidth
                this.height = Math.round(containerWidth/this.videoAspect) // 1920/(16/9) = 1080
                this.marginTop = (containerHeight/2) - (this.height/2) // height/2 - window.height/2;
                this.marginLeft = 0
                
            }
            // Portrait (taller)
            else if (containerAspect < this.videoAspect) {
                this.marginLeft = -Math.round(((containerHeight*this.videoAspect) - containerWidth) / 2)
                this.marginTop = 0
                this.width = Math.round(this.videoAspect*containerHeight) // (16/9)*1080 = 1920
                this.height = containerHeight
            }
            
        },
        

    }
}
</script>


<style lang="scss" scoped>
.video-container {
    position: absolute;
    background-size: cover;
    background-position: center;
    overflow: hidden;
    width: 100%;
    height: 100vh;
    background-color: '#000';

    .pixel-overlay {
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        background-image: url("/images/single_pixel.png");
    }
}
</style>
